export const getFormErrors = (errors = {}) =>
  Object.entries(errors).reduce(
    (collection, [name, { message, types }]) => ({
      ...collection,
      [name]: message || types?.message,
    }),
    {}
  );
